var _defs, _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavLogoSceHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1249",
    "data-name": "Group 1249",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177.277,
    height: 48,
    viewBox: "0 0 177.277 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 177.277,
    height: 48,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 47.926,
    height: 47.975,
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9541",
    "data-name": "Path 9541",
    d: "M0,0V40.847H.016l19.793-4.433L.029,29.4l20.02,1.7L5.372,20.349,22.2,26.49,6.015,5.993,26.506,22.065,20.349,5.371,30.571,19.554,29.66.023l6.411,19.591L40.847,0Z",
    transform: "translate(0 0)",
    fill: "#1a1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9542",
    "data-name": "Path 9542",
    d: "M40.847,0V40.872H0V48H47.926V0Z",
    transform: "translate(0 0)",
    fill: "#1a1818"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9543",
    "data-name": "Path 9543",
    d: "M163.937,23.584a2.56,2.56,0,1,1,2.56-2.559A2.562,2.562,0,0,1,163.937,23.584Zm0-4.869a2.31,2.31,0,1,0,2.31,2.31A2.312,2.312,0,0,0,163.937,18.715Z",
    transform: "translate(10.77 1.24)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9544",
    "data-name": "Path 9544",
    d: "M163.425,19.6c0-.094.021-.1.158-.1.8,0,.891.39.891.769,0,.274-.114.716-.848.716-.073,0-.146,0-.2-.007Zm-.777,2.824c.192-.013.391-.022.575-.022.15,0,.35.01.543.022v-.1h-.1c-.192,0-.238-.044-.238-.266v-.947c.353,0,.361.026.519.229l.83,1.085a2.992,2.992,0,0,1,.341-.022,3.144,3.144,0,0,1,.35.022v-.1c-.172-.013-.256-.03-.427-.253l-.607-.789a1.637,1.637,0,0,0-.252-.256.85.85,0,0,0,.759-.841c0-.666-.5-.838-1.063-.838-.2,0-.393.025-.653.025-.183,0-.383-.012-.575-.025v.1h.1c.191,0,.238.042.238.265v2.344c0,.222-.047.266-.238.266h-.1Z",
    transform: "translate(10.847 1.29)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9545",
    "data-name": "Path 9545",
    d: "M55.394,39.953V18.5H68.072v1.39h-8.64v8.276h8.144v1.39H59.432v9H68.2v1.391Z",
    transform: "translate(3.694 1.234)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9546",
    "data-name": "Path 9546",
    d: "M72.384,18.5h6.985c7.745,0,11.42,5.495,11.42,11.123,0,6.852-4.4,10.328-10.658,10.328H72.384Zm4.037,20.06h2.515c6.457,0,7.815-4.668,7.815-8.871,0-5.4-2.517-9.8-7.615-9.8H76.421Z",
    transform: "translate(4.827 1.234)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 4.038,
    height: 21.451,
    transform: "translate(100.627 19.736)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9547",
    "data-name": "Path 9547",
    d: "M105.223,36.15c1.126,1.788,2.318,2.747,4.436,2.747a3.832,3.832,0,0,0,3.84-3.707c0-6.224-10.064-3.278-10.064-10.958,0-3.442,2.88-6.29,6.884-6.29a7.185,7.185,0,0,1,6.457,3.84l-1.391.895a4.673,4.673,0,0,0-4.4-3.045,3.469,3.469,0,0,0-3.508,3.741c0,5.031,10.064,2.912,10.064,10.659,0,3.938-3.443,6.554-7.051,6.554-2.914,0-5.264-.86-6.754-3.344Z",
    transform: "translate(6.898 1.197)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9548",
    "data-name": "Path 9548",
    d: "M130.669,17.942c6.224,0,10.659,5,10.659,11.321s-4.435,11.323-10.659,11.323c-6.191,0-10.626-5-10.626-11.323s4.435-11.321,10.626-11.321m0,21.254c5.165,0,6.323-5.761,6.323-9.933s-1.158-9.93-6.323-9.93-6.289,5.759-6.289,9.93S125.5,39.2,130.669,39.2",
    transform: "translate(8.005 1.197)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9549",
    "data-name": "Path 9549",
    d: "M144.292,39.953V18.5H147.9l11.221,14.764h.067V18.5h1.721V39.953h-1.788L146.08,22.838h-.067V39.953Z",
    transform: "translate(9.623 1.234)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9550",
    "data-name": "Path 9550",
    d: "M55.877,12.908a1.576,1.576,0,0,0,1.449.9,1.252,1.252,0,0,0,1.255-1.212c0-2.033-3.289-1.071-3.289-3.58a2.124,2.124,0,0,1,2.25-2.056A2.344,2.344,0,0,1,59.65,8.213l-.454.292a1.527,1.527,0,0,0-1.438-1,1.134,1.134,0,0,0-1.147,1.222c0,1.644,3.288.953,3.288,3.483a2.215,2.215,0,0,1-2.3,2.141,2.339,2.339,0,0,1-2.207-1.091Z",
    transform: "translate(3.687 0.464)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9551",
    "data-name": "Path 9551",
    d: "M63.905,6.959a3.514,3.514,0,0,1,3.484,3.7,3.484,3.484,0,1,1-6.956,0,3.512,3.512,0,0,1,3.472-3.7m0,6.945c1.688,0,2.066-1.884,2.066-3.245s-.379-3.245-2.066-3.245S61.851,9.3,61.851,10.659s.367,3.245,2.054,3.245",
    transform: "translate(4.03 0.464)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9552",
    "data-name": "Path 9552",
    d: "M69.408,7.142V12.15A1.483,1.483,0,0,0,70.9,13.632c.618,0,1.687-.215,1.687-1.417V7.142h.563v5.235c0,.9-.683,1.968-2.457,1.968-1.156,0-2.606-.443-2.606-2.227V7.142Z",
    transform: "translate(4.541 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9553",
    "data-name": "Path 9553",
    d: "M75.3,14.15V7.6H73.9V7.142h4.11V7.6h-1.4V14.15Z",
    transform: "translate(4.928 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9554",
    "data-name": "Path 9554",
    d: "M78.8,14.15V7.142h1.319v3.082H83V7.142h1.319V14.15H83V10.776H80.118V14.15Z",
    transform: "translate(5.255 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9555",
    "data-name": "Path 9555",
    d: "M85.625,14.15V7.142h4.143V7.6H86.944V10.3H89.6v.453H86.944V13.7h2.867v.453Z",
    transform: "translate(5.71 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9556",
    "data-name": "Path 9556",
    d: "M90.85,14.15V7.142h3.028a1.933,1.933,0,0,1,1.989,2.065c0,1.072-.778,1.537-1.827,1.666L95.9,14.15h-1.45l-1.915-3.59h.087c1.168,0,1.925-.454,1.925-1.5a1.462,1.462,0,0,0-1.666-1.568h-.714V14.15Z",
    transform: "translate(6.059 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9557",
    "data-name": "Path 9557",
    d: "M96.732,14.15V7.142H97.91l3.667,4.824h.02V7.142h.563V14.15h-.583L97.315,8.559h-.021V14.15Z",
    transform: "translate(6.451 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9558",
    "data-name": "Path 9558",
    d: "M112.808,8.69a2.58,2.58,0,0,0-2.022-1.276c-1.709,0-2.575,1.254-2.575,3.277,0,1.579.8,3.115,2.413,3.115a2.523,2.523,0,0,0,2.325-1.536l.465.227a3.128,3.128,0,0,1-3.051,1.86,3.61,3.61,0,0,1-3.569-3.612,3.646,3.646,0,0,1,3.7-3.787,3.332,3.332,0,0,1,2.705,1.45Z",
    transform: "translate(7.122 0.464)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9559",
    "data-name": "Path 9559",
    d: "M118.975,14.162h-1.353l-.746-1.828h-2.412l-.7,1.828h-.617L116,6.959h.023Zm-3.31-4.857-1.018,2.575h2.046Z",
    transform: "translate(7.545 0.464)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9560",
    "data-name": "Path 9560",
    d: "M119.535,14.15V7.142h1.318V13.6h2.814v.551Z",
    transform: "translate(7.972 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 1.321,
    height: 7.008,
    transform: "translate(132.687 7.618)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9561",
    "data-name": "Path 9561",
    d: "M127.413,14.15V7.142h4.022V7.6h-2.7V10.3H131.2v.453h-2.467v3.4Z",
    transform: "translate(8.497 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9562",
    "data-name": "Path 9562",
    d: "M135.205,6.959a3.514,3.514,0,0,1,3.484,3.7,3.484,3.484,0,1,1-6.956,0,3.512,3.512,0,0,1,3.472-3.7m0,6.945c1.688,0,2.066-1.884,2.066-3.245s-.379-3.245-2.066-3.245S133.15,9.3,133.15,10.659s.369,3.245,2.056,3.245",
    transform: "translate(8.785 0.464)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9563",
    "data-name": "Path 9563",
    d: "M139.388,14.15V7.142h3.029a1.932,1.932,0,0,1,1.989,2.065c0,1.072-.779,1.537-1.827,1.666l1.86,3.277h-1.45l-1.915-3.59h.086c1.168,0,1.926-.454,1.926-1.5a1.463,1.463,0,0,0-1.667-1.568h-.714V14.15Z",
    transform: "translate(9.296 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    "data-name": "Path 9564",
    d: "M145.271,14.15V7.142h1.179l3.667,4.824h.02V7.142h.563V14.15h-.583l-4.261-5.592h-.022V14.15Z",
    transform: "translate(9.688 0.476)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 1.318,
    height: 7.008,
    transform: "translate(162.24 7.618)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    "data-name": "Path 9565",
    d: "M160.239,14.162h-1.352l-.747-1.828h-2.412l-.7,1.828h-.617l2.855-7.2h.021Zm-3.31-4.857-1.017,2.575h2.044Z",
    transform: "translate(10.297 0.464)",
    fill: "#1a1818"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogoSceHome);
export default __webpack_public_path__ + "static/media/nav-logo-sce-home.992ba72b5f4f6a91bf16e2b0a18fd10f.svg";
export { ForwardRef as ReactComponent };